import Axios from 'axios'
import Amplify from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'
import Cache from '@aws-amplify/cache'
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers'

const CONFIG_KEY = '__tcf'

const state = {
  config: null
}

Amplify.Logger.LOG_LEVEL = process.env.NODE_ENV !== 'production' ? 'INFO' : 'ERROR'

const getters = {}

const mutations = {
  __reset (state) {
    state.config = null
  },
  setConfig (state, config) {
    state.config = config
  },
  clearConfig (state) {
    state.config = null
  }
}

const actions = {
  async fetchUserConfig ({commit}, username) {
    const cfg = await Axios.get('https://0jjqf0gaue.execute-api.eu-central-1.amazonaws.com/Prod/cfg', {params: {username}})
    commit('setConfig', cfg.data)
    return cfg.data
  },
  configureAmplify ({commit, state}) {
    let cfg = state.config
    if (!cfg) {
      cfg = Cache.getItem(CONFIG_KEY)
    }
    if (cfg) {
      // Fix config to make PubSub and graphql work simultaneously
      if (!cfg.aws.hasOwnProperty('API')) {
        cfg.aws.API = {
          aws_appsync_graphqlEndpoint: cfg.aws.aws_appsync_graphqlEndpoint,
          aws_appsync_authenticationType: cfg.aws.aws_appsync_authenticationType,
          aws_appsync_region: cfg.aws.aws_appsync_region,
        }

        delete cfg.aws.aws_appsync_authenticationType
        delete cfg.aws.aws_appsync_graphqlEndpoint
        delete cfg.aws.aws_appsync_region
      }

      commit('setConfig', cfg)

      Amplify.addPluggable(new AWSIoTProvider({
        aws_pubsub_region: 'eu-central-1',
        aws_pubsub_endpoint: 'wss://afd9zs97cv90d-ats.iot.eu-central-1.amazonaws.com/mqtt'
      }))

      Amplify.configure(cfg.aws)

      // Send JWT token to get all Cognito claims in AppSync
      Amplify.configure({
        API: {
          graphql_headers: async () => {
            try {
              const token = (await Auth.currentSession()).idToken.jwtToken
              return {Authorization: token}
            } catch (e) {
              console.error(e)
              return {}
            }
          }
        }
      })
    }
    return cfg
  },
  storeConfig ({state}) {
    Cache.setItem(CONFIG_KEY, state.config)
    return state.config
  },
  clearConfig ({commit}) {
    commit('clearConfig')
    Cache.removeItem(CONFIG_KEY)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
